// Tanner Fry
// tannerf1101@yahoo.com
// App settings that are global.

// http://3.98.93.165:8080
// Localhost dev domain: https://www.npmjs.com/package/local-cors-proxy

export const _settings = {
    // API HOSTNAME should be https://lostinedrone.com when deploying
    API_HOSTNAME: 'https://lostinedrone.com',
    // API_DEV_HOSTNAME: 'http://localhost:7778',  // Use for knowing what host the API is on and pinging it correctly
    API_DEV_HOSTNAME: 'http://localhost:7778',  // Use for knowing what host the API is on and pinging it correctly
    API_SSE_NOTIFICTION_URL: '/api/sse/general-notification',
    API_COMPUTER_PORT: '7778',
    API_CONTAINER_PORT: '7778',
    APP_COMPUTER_PORT: '7777',
    APP_CONTAINER_PORT: '3000',  // React default port
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'dev',  // Can be dev or prod (set via REACT_APP_ENVIRONMENT env var)
    ENABLE_MOBILE: false,  // Used for mobile development
    MYSQL_COMPUTER_PORT: '3308',
    MYSQL_CONTAINER_PORT: '3306',  // MySQL default port
    IS_CONSTANT_LOADING_ENABLED: false,  // Used for quick refreshes on app.
    // Google Analytics configuration
    GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '',
    ENABLE_ANALYTICS: process.env.REACT_APP_GOOGLE_ANALYTICS_ID ? true : false,
};

export const _settings_customer = {
    SQUARE_APP_ID: 'sq0idp-6SStw0LHafeRsjc4igoyzQ',
    SQUARE_LOCATION_ID: 'LJ8MFGYQN0SBQ',
    SQUARE_TEST_APP_ID: 'sandbox-sq0idb-zwACMUNBSn7DA-nF8zUMig',
    SQUARE_TEST_LOCATION_ID: 'LSG0Y012T3ZJ6',
    NOTICE_BANNERS: [
        {
            location: '/',
            title: '',
        },
        {
            location: '/dashboard',
            title: '',
        },
        {
            location: '/news',
            title: '',
        },
        {
            location: '/weather',
            title: '',
        }
    ],
};

export const _settings_weather = {
    units: 'imperial', // imperial or metric
};

// A list of non private routes that can be exported
export const _settings_non_private_routes = [
	'/',
	'/about',
	'/pricing',
	'/login',
	'/register',
    '/services',
];


export const getCorrectDomain = () => {
    if (_settings.ENVIRONMENT === 'dev') {
        return _settings.API_DEV_HOSTNAME;
    } else if (_settings.ENVIRONMENT.includes('192.168.0.')) {
        return _settings.ENVIRONMENT;  
    } else {
        return _settings.API_HOSTNAME;
    }
}

export default _settings;